export const getAppVersion = () => {
  try {
    if (typeof window !== 'undefined' && window.Android?.getAppVersion) {
      return window.Android.getAppVersion()
    }
  } catch (e) {
    // ignore
  }
  return 'web'
}
